import styles from './category-card.module.scss';
import { getUnits } from 'utils/units';
import { useTranslation } from 'react-i18next';

export default function CategoryCard(props) {
  const { t } = useTranslation();
  const { value, title } = props;

  return (
    <div className={styles.category__card}>
      <span className={styles.category__title}>{title}</span>
      <span className={styles.category__value}>
        {t('report.total', { value: value, units: getUnits().area })}
      </span>
    </div>
  );
}
